import { PackageBuilderSummaryProduct } from './package-builder-summary-product.model';

export class PackageBuilderSelections {
  selectedWheel: PackageBuilderSummaryProduct;
  selectedTire: PackageBuilderSummaryProduct;
  selectedLabours: PackageBuilderSummaryProduct[];
  selectedHardwares: PackageBuilderSummaryProduct[];

  constructor () {
    this.selectedWheel = new PackageBuilderSummaryProduct();
    this.selectedTire = new PackageBuilderSummaryProduct();
    this.selectedLabours = new Array<PackageBuilderSummaryProduct>();
    this.selectedHardwares = new Array<PackageBuilderSummaryProduct>();
  }
}
